export const scrollToTargetSection = (targetElementSelector: string, targetElementText: string): void => {

    const categoriesEl = document.querySelector(
        `[data-test-selector="${targetElementSelector}"]`,
    ) as HTMLElement | null;
    if (categoriesEl) {
        const header = document.querySelector('[data-test-selector="header"]') as HTMLElement | null;
        const headerHeight = header ? header.offsetHeight : 165;
        const yOffset = -(headerHeight + 20);
        const y = categoriesEl.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
    }

};

const getDefaultSectionScrollOffset = () => (window.innerWidth > 1088 ? 167 : window.innerWidth > 990 ? 113 : 98);
